import * as yup from "yup";
import { emailRegEx } from "./RegEx";

export const subscriptionSchema = yup.object().shape({
  email: yup
    .string()
    .matches(emailRegEx, "Should be valid email")
    .required("Email is required"),
});
